'use strict';

var DetailsLengthOfStayGridService = function DetailsLengthOfStayGridService() {
  function cellClassName(rowId, datafield, value, row) {
    var className = '';
    if (datafield === 'direction') {
      className = 'direction-column';
      if (value === 'Outbound') {
        className += ' outbound-cell';
      } else if (value === 'Inbound') {
        className += ' inbound-cell';
      }
      if (row.isExcluded) {
        className += ' triangled-corner triangled-corner-blue';
      }
    }
    if (row.isServiceGroupEnd) {
      className += ' service-end';
    }
    if (datafield === 'fareClass') {
      className += 'fare-class-cell';
    }
    return className;
  }
  return {
    cellClassName: cellClassName
  };
};
DetailsLengthOfStayGridService.$inject = [];
module.exports = DetailsLengthOfStayGridService;